"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Allows the user to interact with the event.
 *
 * @class EventManagement
 * @implements {IEventManagement}
 */
var EventManagement = /** @class */ (function () {
    function EventManagement(unsub) {
        this.unsub = unsub;
        this.propagationStopped = false;
    }
    EventManagement.prototype.stopPropagation = function () {
        this.propagationStopped = true;
    };
    return EventManagement;
}());
exports.EventManagement = EventManagement;



//////////////////
// WEBPACK FOOTER
// C:/Users/Benoit/WebstormProjects/schiltz/server/node_modules/ste-core/dist/management.js
// module id = ../../../../../../server/node_modules/ste-core/dist/management.js
// module chunks = main